'use strict';

import React from 'react';

require('styles//Addresses.css');

class AddressesComponent extends React.Component {
  render() {
    return (
      <div className="addresses-component" id="content">
      <strong>Адрес:</strong><br/><span>Центральный офис: Республика Казахстан, г. Алматы, ул.Кошкунова, дом 4а</span>
      <br/><br/><strong>Контакты:</strong><br/><span>г. Алматы телефон: (727) 241-12-16<br/>Отдел закупа: (727)291-65-07<br/> факс: (727) 291-17-67 e-mail: office@medinfo.kz</span>
      <br/><br/><strong>Филиал г. Астана</strong><span> Дом Министерств, каб.914<br/>  телефон: (7172) 74-34-26</span>
      </div>
    );
  }
}

AddressesComponent.displayName = 'AddressesComponent';

// Uncomment properties you need
// AddressesComponent.propTypes = {};
// AddressesComponent.defaultProps = {};

export default AddressesComponent;



// WEBPACK FOOTER //
// ./src/components/AddressesComponent.js